import { Component, inject } from '@angular/core';
import { PortalInvitee } from '@models/portal-invites';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { MODAL_DATA } from 'src/app/ui/modal/modal-data.token';

@Component({
	selector: 'app-remove-contact-access-modal',
	templateUrl: './remove-contact-access-modal.component.html',
	imports: [AtomicModule],
})
export class RemoveContactAccessModalComponent {
	modalData = inject(MODAL_DATA) as {
		invitee: PortalInvitee;
	};
}
